var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useRef, useState } from 'react';
import axios from 'axios';
import { useError } from '../context';
import methods from '../api/request';
export var useAsync = function (method) {
    if (method === void 0) { method = 'get'; }
    var _a = __read(useError(), 2), error = _a[0], setError = _a[1];
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var tokenSource = useRef();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var onRequest = useCallback((function (url, params, options) {
        var _a, _b;
        setLoading(true);
        (_a = tokenSource.current) === null || _a === void 0 ? void 0 : _a.cancel();
        tokenSource.current = axios.CancelToken.source();
        var cancelToken = (!(options === null || options === void 0 ? void 0 : options.disablesRaceCondition) &&
            ((_b = tokenSource.current) === null || _b === void 0 ? void 0 : _b.token));
        return methods[method](url, params, __assign({ cancelToken: cancelToken }, options))
            .catch(function (err) {
            var _a;
            setError(__assign(__assign({}, err), { status: (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status }));
            throw err;
        })
            .finally(function () {
            tokenSource.current = undefined;
            setLoading(false);
        });
    }), [method]);
    return [onRequest, loading, error];
};
//# sourceMappingURL=useAsync.js.map